import calculateEffectiveFate from './calculateEffectiveFate';
import makeFateRefreshCard from './makeFateRefreshCard';

export default function fetchSuccess(state, payload) {
  const {
    currentFate,
    currentNex,
    isExceptionalFriend,
    premiumSubExpiryDateTime,
    ...payloadRest
  } = payload;

  const fateCards = [
    makeFateRefreshCard(payload),
    ...payload.fateCards,
  ];

  return {
    ...state,
    isExceptionalFriend,
    premiumSubExpiryDateTime,
    hasFetched: true,
    isFetching: false,
    data: {
      ...payloadRest,
      currentFate: calculateEffectiveFate({ currentFate, currentNex }),
      fateCards,
    },
  };
}